import React, { useState, useEffect, PropsWithChildren } from 'react'
import MFA from 'mfa-widget'

interface MFAWrapperProps {
    sessionKey: string
    url: 'stage' | 'dev' | 'preprod' | 'prod' | string // stage is default
    mode: 'modal' | 'window' | 'anchor' // modal is default, for anchor keep the anchor div in the page & set the anchor id to mfaAnchor
    onSessionOpened?: () => void
    onFactorCompleted?: () => void
    onSessionCompleted: () => void
    onSessionFailed: () => void
    onChangeRequested?: () => void
    onClosed?: () => void
}

/**
 *
 */
const MFAWrapper = ({ sessionKey, url, mode, onSessionOpened, onFactorCompleted, onSessionCompleted, onSessionFailed, onChangeRequested, onClosed, children }: PropsWithChildren<MFAWrapperProps>) => {
    const [mfaCompleted, setMfaCompleted] = useState(false)
    const [mfa] = useState(new MFA())

    const getMFAConfig = () => {
        let stage = 'stage'
        let origin
        if (url) {
            stage = url
            if (url.startsWith('http')) origin = url
        }

        let mfaMode
        if (mode === 'window') mfaMode = mode

        const config: { stage: string, MFAOrigin?: string, mode?: string } = { stage, MFAOrigin: origin }
        if (mfaMode) config.mode = mfaMode

        return config
    }

    useEffect(() => {
        const MFAEvents = {
            MFASessionOpened: () => onSessionOpened && onSessionOpened(),
            MFAFactorCompleted: () => onFactorCompleted && onFactorCompleted(),
            MFASessionCompleted: () => { setMfaCompleted(true); onSessionCompleted() },
            MFASessionFailed: onSessionFailed,
            MFAChangeRequested: () => onChangeRequested && onChangeRequested(),
            MFAClosed: () => onClosed && onClosed()
        }

        const config = getMFAConfig()
        mfa.init(MFAEvents, config)

        return () => {
            mfa.deactivate()
        }
    }, [])

    const openMFA = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault()
        e.stopPropagation()
        mfa.open(sessionKey)
    }

    return (
        <div onClick={(e) => !mfaCompleted && openMFA(e)} style={{ cursor: mfaCompleted ? 'default' : 'pointer' }} data-testid='mfa-wrapper'>
            {children}
        </div>
    )
}

MFAWrapper.displayName = 'MFAWrapper'
MFAWrapper.defaultProps = { url: 'stage', mode: 'modal', children: null }

export default MFAWrapper
